import Swiper from "swiper/bundle";

const NextSlider = () => {
  const sliders = Array.from(document.querySelectorAll(".next-slider"));
  if (sliders.length > 0) {
    sliders.forEach((slider) => {
      const initSlider = new Swiper(slider, {
        spaceBetween: 24,
        slidesPerView: 1.1,
        lazy: {
          loadPrevNext: true,
        },
        breakpoints: {
          767: {
            slidesPerView: 2,
          },
        },
      });
    });
  }
};

export default NextSlider;
